import { render } from "./profit.vue?vue&type=template&id=415b0359&ts=true"
import script from "./profit.vue?vue&type=script&lang=ts"
export * from "./profit.vue?vue&type=script&lang=ts"

import "./profit.vue?vue&type=style&index=0&id=415b0359&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__